export enum frequencyState {
  day = 1,
  week = 2,
  month = 3,
}

export enum login_status {
  online = 1,
  offline = 2
}

export enum union {
  KB = 0,
  MB = 1
}

/** 文案请用 traffic-control-i18n-labels 中 get*LabelMap + vue-i18n */
